import { ScoreType } from "@/modules/scores/scoreTypes"
import { type ExerciseCategory } from "@/modules/sessions/sessionDetails/blocks/exerciseBlock/exerciseTypes"
import type { ExerciseFormikType } from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import { word } from "@modules/core/utils/i18n"

export const getDisplayExerciseCategory = (category: ExerciseCategory, otherCategory: string | null): string => {
  switch (category) {
    case "WARM_UP":
      return word("exercise.category.warmup.name")
    case "SKILLS":
      return word("exercise.category.skills.name")
    case "SPECIFIC_WOD":
      return word("exercise.category.specificWod.name")
    case "WOD":
      return word("exercise.category.wod.name")
    case "BODY_BUILDING":
      return word("exercise.category.bodyBuilding.name")
    case "MOVEMAX_OD":
      return word("exercise.category.movemax_od.name")
    case "OTHER":
      return otherCategory && otherCategory !== "" ? otherCategory : word("exercise.category.other.name")
    case "MOBILITY":
      return word("exercise.category.mobility.name")
  }
}

export const GetNewExerciseDraft = (): ExerciseFormikType => {
  return {
    category: "WARM_UP",
    description: "",
    id: null,
    rpe: null,
    title: "",
    chrono: null,
    requiredMedia: false,
    durationInMin: null,
    otherCategory: "",
    scoreSetConfigurations: [],
    scoringOption: null,
    chronoType: "NONE",
    chronoForTime: null,
    chronoTabata: null,
    chronoEmom: null,
    chronoAmrap: null,
    scoreType: ScoreType.NO_SCORE,
  }
}
